import Flickity from 'flickity';

function LogoCarousel({ node }) {
	const previousButton = node.querySelector('.button--previous');
	const nextButton = node.querySelector('.button--next');
	const carouselElement = node.querySelector('.carousel') ?? node;

	const defaultOptions = {
		cellAlign: 'center',
		pageDots: false,
		wrapAround: true,
		prevNextButtons: false,
		cellSelector: '.carousel__item',
		draggable: false,
		pauseAutoPlayOnHover: false,
		resize: false,
	};

	const options = node.dataset.carouselOptions
		? JSON.parse(node.dataset.carouselOptions)
		: {};

	const combinedOptions = { ...defaultOptions, ...options };

	const carousel = new Flickity(carouselElement, combinedOptions);

	carousel.x = 0;

	// Start the marquee animation
	play();

	// Main function that 'plays' the marquee.
	function play() {
		// Set the decrement of position x
		carousel.x -= 1.5;

		// Settle position into the slider
		carousel.settle(carousel.x);

		// Set the requestId to the local variable
		window.requestAnimationFrame(play);
	}

	if (previousButton) {
		previousButton.addEventListener('click', () => {
			carousel.previous();
		});
	}

	if (nextButton) {
		nextButton.addEventListener('click', () => {
			carousel.next();
		});
	}

	return () => {
		carousel.destroy();
	};
}

export default LogoCarousel;
